import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Http, Response} from '@angular/http';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Storage} from '@ionic/storage';
import * as Config from '../../app/app.config';
import {DateTimeProvider} from '../../providers/datetime/datetime';
import {AuthProvider} from '../auth/auth';
import {QuestionAnswer} from '../../models/questionanswer';
import {QuestionSituation} from '../../models/questionsituation';

/*
  Generated class for the ProofProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ProofProvider {

  private proof: any = null;
  private currentIdentificationQuestionIdx: number = -1;
  private currentIdentificationQuestion: any = null;
  private currentQuestionIdx: number = -1;
  private currentQuestion: any = null;

  constructor(
    private http: Http,
    private auth: AuthProvider,
    private storage: Storage,
    private dateTimeProvider: DateTimeProvider
  ) {
    console.log('Hello ProofProvider Provider');
  }

  initiate(proof: any) {
    this.proof = proof;
    this.resetIdentificationQuestions();
    this.resetQuestions();
  }

  initiateQuestions(proof: any) {
    this.proof = proof;
  }

  hasProof() {
    return (this.proof != null);
  }

  destroy() {
    this.proof = null;
  }

  getId() {
    return (this.proof) ? this.proof.id : null;
  }

  getIdProof() {
    return (this.proof) ? this.proof.proofId : null;
  }

  async resetIdentificationQuestions() {
    // let that = this;
    this.currentIdentificationQuestionIdx = -1;
    this.currentIdentificationQuestion = null;

    // await this.storage.get('userproof_' + this.proof.id + '_current_identification_question_idx').then((data: any) => {
    //   if (data) {
    //     that.currentIdentificationQuestionIdx = data;

    //     if ((that.proof.identificationQuestions.length - 1) < that.currentIdentificationQuestionIdx) {
    //       that.currentIdentificationQuestionIdx = (that.proof.identificationQuestions.length - 1);
    //     }
    //   }
    // });
  }

  backQuestions() {
    this.currentQuestionIdx = 0;
    this.currentQuestion = this.proof.questions[this.currentQuestionIdx];
    return this.currentQuestion;
  }

  async resetQuestions() {
    let that = this;
    this.currentQuestionIdx = -1;
    this.currentQuestion = null;

    await this.storage.get('userproof_' + this.proof.id + '_currentquestion_idx').then((data: any) => {
      if (data) {
        that.currentQuestionIdx = data;
        // console.log("Current Question ------------>", data);

        try {
          if ((that.proof.questions.length - 1) < that.currentQuestionIdx) {
            that.currentQuestionIdx = (that.proof.questions.length - 1);
          }
        } catch (e) {
          // Do nothing.
        }
      }
    });
  }

  getCurrentIdentificationQuestion(): any {
    this.currentIdentificationQuestion = null;

    if (this.currentIdentificationQuestionIdx === -1) {
      this.currentIdentificationQuestionIdx = 0;
    }

    if ((this.proof.identificationQuestions.length - 1) >= this.currentIdentificationQuestionIdx) {
      this.currentIdentificationQuestion = this.proof.identificationQuestions[this.currentIdentificationQuestionIdx];
    }

    return this.currentIdentificationQuestion;
  }

  getNextIdentificationQuestion(): any {
    this.currentIdentificationQuestion = null;

    if ((this.proof.identificationQuestions.length - 1) > this.currentIdentificationQuestionIdx) {
      this.currentIdentificationQuestionIdx++;
      // this.storage.set('userproof_' + this.proof.id + '_current_identification_question_idx', this.currentIdentificationQuestionIdx);
      this.currentIdentificationQuestion = this.proof.identificationQuestions[this.currentIdentificationQuestionIdx];
    }

    return this.currentIdentificationQuestion;
  }

  getCurrentIdentificationQuestionIdx() {
    return this.currentIdentificationQuestionIdx;
  }

  getIdentificationQuestionsTotal() {
    return this.proof.identificationQuestions.length;
  }

  getProofLinks() {
    return this.proof.links;
  }

  getProofQuestions() {
    console.log('this.proof--->', this.proof.questions);
    return this.proof.questions;
  }

  getCurrentQuestion(): any {
    this.currentQuestion = null;

    if (this.currentQuestionIdx === -1) {
      this.currentQuestionIdx = 0;
    }

    if ((this.proof.questions.length - 1) >= this.currentQuestionIdx) {
      this.currentQuestion = this.proof.questions[this.currentQuestionIdx];
    }

    return this.currentQuestion;
  }

  getNextQuestion(): any {
    this.currentQuestion = null;

    if ((this.proof.questions.length - 1) > this.currentQuestionIdx) {
      this.currentQuestionIdx++;
      this.storage.set('userproof_' + this.proof.id + '_currentquestion_idx', this.currentQuestionIdx);
      this.currentQuestion = this.proof.questions[this.currentQuestionIdx];
    }

    return this.currentQuestion;
  }

  getNavigateQuestion(index) {
    let that = this;
    this.currentQuestion = null;
    if ((this.proof.questions.length - 1) > this.currentQuestionIdx) {
      that.currentQuestionIdx = index;
      this.storage.set('userproof_' + this.proof.id + '_currentquestion_idx', that.currentQuestionIdx);
      this.currentQuestion = this.proof.questions[that.currentQuestionIdx];
    }

    return this.currentQuestion;
  }

  getCurrentQuestionIdx() {
    return this.currentQuestionIdx;
  }

  getQuestionsTotal() {
    return this.proof.questions.length;
  }

  getTerms() {
    return this.proof.terms;
  }

  async getDuration() {
    let that = this;

    await this.storage.get('userproof_' + this.proof.id + '_duration').then((data: any) => {
      if (data) {
        that.proof.duration = data;
      }
    });

    return this.proof.duration;
  }

  setDuration(duration: number) {
    if (this.proof) {
      this.proof.duration = duration;
      this.storage.set('userproof_' + this.proof.id + '_duration', duration);
    }
  }

  getDurationMin() {
    return this.proof.durationMin;
  }

  getAdvice() {
    return this.proof.advice;
  }

  isWebcamRequired() {
    return this.proof.webcamRequired;
  }

  isPermitConsult() {
    //  console.log('isPermitConsult', this.proof);
    return this.proof.isPermitConsult;
  }

  isNavigate() {
    console.log('isNavigate', this.proof);
    return this.proof.isNavigate;
  }

  getProofId() {
    console.log('this.proof.proofId --->', this.proof.proofId);
    return this.proof.getProofId;
  }

  addIdentificationAnswer(questionId: number, answerId: any, callback: any) {
    if (answerId) {
      let questionAnswer = new QuestionAnswer();
      questionAnswer.kind = 'IQTA';
      questionAnswer.id = questionId;
      questionAnswer.answerId = parseInt(answerId, 10);
      questionAnswer.captured = this.dateTimeProvider.getISOString();

      this.storage.set('userproof_' + this.proof.id + '_identification_question_' + questionAnswer.id, JSON.stringify(questionAnswer));
    }

    if (callback) {
      callback();
    }
  }

  addAnswer(questionId: number, answerId: any) {
    if (answerId) {
      let questionAnswer = new QuestionAnswer();
      questionAnswer.kind = 'QTA';
      questionAnswer.id = questionId;
      questionAnswer.answerId = parseInt(answerId, 10);
      questionAnswer.captured = this.dateTimeProvider.getISOString();

      this.storage.set('userproof_' + this.proof.id + '_question_' + questionAnswer.id, JSON.stringify(questionAnswer));
    }
  }

  isFinished(_proof: any = null): Observable<boolean> {
    let that = this;

    if (!_proof) {
      _proof = that.proof;
    }

    return Observable.create((observer: any) => {
      if (_proof) {
        that.storage.get('userproof_' + _proof.id + '_finished').then((value: boolean) => {
          if (value) {
            that.storage.get('userproof_' + _proof.id).then((value: any) => {
              if (value) {
                that.proof = JSON.parse(value);
              }
            }).catch((error: any) => {
              console.log('Error on fetch proof', error);
            });

            observer.next(true);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        }).catch((error: any) => {
          console.log(error);
          observer.next(false);
          observer.complete();
        });
      } else {
        observer.next(false);
        observer.complete();
      }
    });
  }

  async setFinished() {
    await this.storage.set('userproof_' + this.proof.id + '_finished', true);
  }

  getAnswersAndSituations(): Observable<Promise<any>[]> {
    let that = this;

    return Observable.create((observer: any) => {
      that.storage.keys().then((keys: string[]) => {
        const promises = [];

        keys.forEach((key: string) => {
          if ((key.includes('userproof_' + that.proof.id + '_identification_question')) || (key.includes('userproof_' + that.proof.id + '_question'))) {
            promises.push(that.storage.get(key));
          }
        });

        observer.next(promises);
        observer.complete();
      }).catch((error: any) => {
        observer.error(new Error(error));
      });
    });
  }

  addSituation(situation: QuestionSituation, onFinish: any = null) {
    if (situation) {
      const key = 'userproof_' + this.proof.id + '_question_' + this.dateTimeProvider.getString();
      const value = JSON.stringify(situation);

      this.storage.set(key, value)
        .then(() => {
          if (onFinish) {
            onFinish();
          }
        })
        .catch((error: any) => {
          if (onFinish) {
            onFinish(error);
          }
        })
    }
  }

  isWebWithoutCamera(): boolean {
    let result = false;

    try {
      result = ((this.proof.accessKind === 'WEB') && (!this.proof.webcamRequired));
    } catch (e) {
      // Do nothing.
    }

    return result;
  }

  setWebcamRequired(webcamRequired: boolean) {
    this.proof.webcamRequired = true;
  }


  // getFileToken() {
  //     var headers = new Headers();
  //     headers.append('Authorization', 'Bearer ' + this.auth.getToken());

  //     let url = Config.baseUrl + '/proofquestions/file/token';

  //     return this.http.get(url, {headers: headers})
  //         .map((res: Response) => res.json());
  // }

  // getFileUrl(id: number, fileId: any, fileToken: string) {
  //     return Config.baseUrl + '/proofquestions/' + id + '/file/' + fileId + '?token=' + fileToken;
  // }

  getQuestionFiles() {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();

    return this.http.get(Config.baseUrl + '/files/getquestionfiles', {headers: headers}).map((res: Response) => res.json());
  }

  getLockScreenData() {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();

    return this.http.get(Config.baseUrl + '/proofs/' + this.proof.proofId + '/lockproofdata', {headers: headers}).map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/proof/proof.ts